import React, {Component} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import CreateDialog from "../CreateDialog/CreateDialog";

/**
 * Input properties:
 * <ul>
 * <li>value:  Set the current value of the field - defaults to empty string</li>
 * <li>editHandler: Required The name of the function to be called to handle the activation or inactivation.  It should expect the new or updated value to be passed</li>
 * <li>header: Define what the message header should be - defaults to 'Set Value'</li>
 * <li>title: Define something to display during a hover over - defaults to 'Set Value'</li>
 * <li>validationHandler:  An optional function for validation on the field value</li>
 * <li>contextItem:  Optional: When dealing with multiple edit items in a list, will be passed as the second parameter to editHandler and validationHandler </li>
 * </ul>
 */
export default class EditField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newValue: this.props.value,
            isDialogLoading: false,
            isAddValueModalVisible: false,
            target: {},
            isValid: true
        }
    }

    handleAddValueDialogToggle = () => {
        if (!this.state.isAddValueModalVisible) {
            this.setState({
                isAddValueModalVisible: !this.state.isAddValueModalVisible
            });
        }
    };

    validateValue = e => {
        let localValue;
        let isValid = true;
        if (this.props.validationHandler) {
            isValid = this.props.validationHandler(e.target.value, this.props.contextItem);
        }
        console.log(e.target.checked);
        if (this.props.type === "checkbox") {
            localValue = e.target.checked
        } else {
            localValue = e.target.value
        }
        this.setState({
            newValue: localValue,
            target: e.target,
            isValid: isValid
        })
    };

    cancelAction = () => {
        this.setState({
            newValue: this.props.value,
            isAddValueModalVisible: false
        })
    }

    saveAction = () => {
        if (this.props.type === "checkbox") {
            this.props.editHandler(this.state.target, this.props.contextItem);
        } else {
            this.props.editHandler(this.state.newValue, this.props.contextItem);
        }
        this.setState({
            isAddValueModalVisible: false
        })
    }
    render() {
        return (
            <span>
                {this.props.type !== "checkbox" ? this.props.value : this.props.label} &nbsp;
                {this.props.canEdit &&
                <FontAwesomeIcon
                    className="edit edit-icon"
                    icon="edit"
                    size="sm"
                    title={this.props.title}
                    color="#62BB46"
                    onClick={() => this.setState({
                        newValue: this.props.value,
                        isAddValueModalVisible: true
                    })}
                />
                }

                {/* Add/Edit attribute value */}
                <CreateDialog
                    isModalVisible={this.state.isAddValueModalVisible}
                    isDialogLoading={this.state.isDialogLoading}
                    handleDialogToggle={this.handleAddValueDialogToggle}
                    cancelAction={this.cancelAction}
                    action={this.saveAction}
                    modalHeaderName={this.props.header}
                    modalBodyFields={[
                        {
                            label: this.props.label ? this.props.label : "Value",
                            id: "value",
                            inputType: this.props.type ? this.props.type : "text",
                            onChange: this.validateValue,
                            validateFieldName: "",
                            isFieldInvalid: !this.state.isValid,
                            newField: this.state.newValue,
                            defaultValue: this.props.value,
                            maxLength: this.props.maxLength
                        }
                    ]}
                />
            </span>
        )
    }
}


// WEBPACK FOOTER //
// ./src/common/EditField/EditField.js